<template>
  <div>
    <div class="section-header">New Course</div>
    <edit :course="course" />
  </div>
</template>

<script>
import edit from "../courseForm";
import User from "@/services/api/authUser";

export default {
  components: {
    edit
  },
  data() {
    return {
      course: {
        owner: User.id,
        modules: [],
        background_img: undefined
      }
    };
  },
  methods: {}
};
</script>
